<div class="flex items-center justify-between gap-2 px-2.5 py-1.5 rounded-lg bg-gray-50 border border-gray-100">
    <div class="flex items-center gap-2 min-w-0">
        <div class="w-6 h-6 rounded-full bg-blue-100 flex items-center justify-center flex-shrink-0">
            <mat-icon class="text-blue-500"
                style="font-size:13px;width:13px;height:13px;line-height:13px">person</mat-icon>
        </div>
        <div class="min-w-0">
            <p class="text-xs font-medium text-gray-800 truncate">{{ fullName }}</p>
            <p class="text-[10px] text-gray-400 truncate">{{ email }}</p>
        </div>
    </div>
    @if (isRemoving) {
    <mat-spinner diameter="16" class="flex-shrink-0"></mat-spinner>
    } @else {
    <button mat-icon-button color="warn" (click)="onRemove()" matTooltip="Remove from group"
        class="!w-6 !h-6 !leading-6 flex-shrink-0">
        <mat-icon style="font-size:14px;width:14px;height:14px">person_remove</mat-icon>
    </button>
    }
</div>